/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import ModeratorStatusOptions from "data/Prod/CompanyModeratorStatus.json";
import { reactSelectStyle } from "Config/Config";

const MemberDetailsModal = ({
  afterModalClose,
  selectedMemberId,
  setSelectedMemberId,
}) => {
  const { t } = useTranslation(); //for translation
  const params = useParams();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [rolesList, setRolesList] = useState([]);

  const [userInput, setUserInput] = useState("");
  const [userOptions, setuserOptions] = useState([]);
  const [userValue, setUserValue] = useState(null);
  const [userId, setUserId] = useState(null);
  const [userEmail, setUserEmail] = useState("");
  const [roleValue, setRoleValue] = useState(null);
  const [roleData, setRoleData] = useState(null);
  const [memberShipStatusValue, setMemberShipStatusValue] = useState(null);
  const [memberShipData, setmemberShipData] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const [isAdding, setIsAdding] = useState(false);

  //** Hooks for validation */
  const [errors, setErrors] = useState({});

  //** Function for Validation (updated for correctness and clarity) */
  const validateForm = () => {
    const newErrors = {};
    const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    // Case 1: User must be selected.
    if (!userValue || userEmail === "") {
      newErrors.user = t("Please select or invite a user by name or email.");
    }

    // Case 2: User email field must not be empty.
    // Run further checks only if an email is provided
    if (userEmail !== "" && !userEmail.match(mailformat)) {
      newErrors.userEmailIsNotValid = t("Invalid email format") + " !";
    }

    // Case 4: User cannot add themselves.
    if (userInfo.email === userEmail) {
      newErrors.userEmailExists =
        t("You cannot add yourself as a member.") + " !";
    }

    // Role validation
    if (!roleValue) {
      newErrors.role = t("Please assign a role to this member.");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //function for get user details
  const getUserList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USERLIST_OPTIONS +
        `?token=${token}` +
        `&userstringinput=${userInput}`;

      const response = await getData(requestUrl);

      if (response.status) {
        if (response.data.length > 0) {
          setuserOptions(response.data);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get user input
  const userInputHandler = (val) => {
    setUserInput(val);
  };

  //function for get all roles
  const getAllCompanyRoles = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_MODULE_ROLES +
        `?token=${token}&slug=MOD_COMPANY`;

      const response = await getData(requestUrl);

      if (response.status) {
        setRolesList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function user Selection
  const userSelectionHandler = (val) => {
    if (val) {
      setUserValue(val);
      val._id ? setUserId(val._id) : setUserId(null);
      val.email ? setUserEmail(val.email) : setUserEmail(val.value);
    } else {
      setUserValue(null);
      setUserId(null);
      setUserEmail("");
      setuserOptions([]);
    }
    // Clear all user-related errors on change
    if (errors.user || errors.userEmailExists || errors.userEmailIsNotValid) {
      setErrors((prev) => ({
        ...prev,
        user: "",
        userEmailExists: "",
        userEmailIsNotValid: "",
      }));
    }
    setErrorMessage("");
  };

  //function for select role
  const roleSelectionHandler = (val) => {
    if (val) {
      setRoleValue(val);
      setRoleData(val.value);
    } else {
      setRoleValue(null);
      setRoleData(null);
    }
    if (errors.role) {
      setErrors((prev) => ({ ...prev, role: "" }));
    }
  };

  //function for select memebership status
  const memberShipStatusSelectionHandler = (val) => {
    if (val) {
      setMemberShipStatusValue(val);
      setmemberShipData(val.value);
    } else {
      setMemberShipStatusValue(null);
      setmemberShipData(null);
    }
  };

  //function for get member details
  const getMemberDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_COMPANY_MEMBER_DETAILS +
        `/${selectedMemberId}?token=${token}`;

      const response = await getData(requestUrl);

      if (response.status && response.data) {
        userSelectionHandler(response.data.companymember);
        roleSelectionHandler(response.data.memberrole);
        for (let status of ModeratorStatusOptions) {
          if (status.value == response.data.moderatorstatus) {
            memberShipStatusSelectionHandler(status);
          }
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for save member
  const saveMemberHandler = async () => {
    if (!validateForm()) {
      return;
    }
    setIsAdding(true);
    try {
      let companyMemberData = {
        company: params.id,
        user: userId,
        role: roleData,
        useremail: userEmail,
        moderatorstatus: memberShipData,
        memberstatus: "1",
      };

      let response = {};

      if (selectedMemberId) {
        let requestUrl =
          url.API_BASE_URL +
          url.API_UPDATE_COMPANY_MEMBER +
          `/${selectedMemberId}?token=${token}`;

        response = await putData(requestUrl, companyMemberData);
      } else {
        let requestUrl =
          url.API_BASE_URL + url.API_ADD_NEW_COMPANY_MEMBER + `?token=${token}`;

        response = await postData(requestUrl, companyMemberData);
      }

      setIsAdding(false);

      if (response.status) {
        resetHandler();
        const memberModal = document.querySelector("#addCompanyMember");
        const modal = bootstrap.Modal.getInstance(memberModal);
        modal.hide();
        afterModalClose();
      } else {
        setErrorMessage(
          response.message || "An error occurred saving the member."
        );
      }
    } catch (error) {
      setIsAdding(false);
      setErrorMessage(error.message);
      console.log(error.message);
    }
  };

  //function for reset
  const resetHandler = () => {
    setUserValue(null);
    setuserOptions([]);
    setMemberShipStatusValue(null);
    setmemberShipData(null);
    setRoleData(null);
    setRoleValue(null);
    setUserInput("");
    setUserId(null);
    setUserEmail("");
    setErrorMessage("");
    setSelectedMemberId(null);
    setErrors({});

    for (let memberStatus of ModeratorStatusOptions) {
      if (memberStatus.value === "1") {
        memberShipStatusSelectionHandler(memberStatus);
      }
    }
  };

  useEffect(() => {
    if (selectedMemberId) {
      getMemberDetails();
    }
  }, [selectedMemberId]);

  useEffect(() => {
    if (userInput.length > 3) {
      getUserList();
    }
  }, [userInput]);

  useEffect(() => {
    getAllCompanyRoles();
    for (let memberStatus of ModeratorStatusOptions) {
      if (memberStatus.value === "1") {
        memberShipStatusSelectionHandler(memberStatus);
      }
    }
  }, []);

  const optionsToShow = userOptions.length > 0 ? userOptions : [];

  // Custom styles for CreatableSelect (User) to show red border on error
  const userSelectCustomStyles = {
    control: (base) => ({
      ...base,
      borderColor:
        errors.user ||
        errors.userEmail ||
        errors.userEmailIsNotValid ||
        errors.userEmailExists
          ? "#dc3545"
          : "#ced4da",
      "&:hover": {
        borderColor:
          errors.user ||
          errors.userEmail ||
          errors.userEmailIsNotValid ||
          errors.userEmailExists
            ? "#dc3545"
            : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
  };

  // Custom styles for Select (Role) to show red border on error
  const roleSelectCustomStyles = {
    control: (base) => ({
      ...base,
      borderColor: errors.role ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.role ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
  };

  return (
    <div
      className="modal fade"
      id="addCompanyMember"
      tabIndex="-1"
      aria-labelledby="addMemberLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          <div className="modal-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary fs-5 icon-md">
                  group
                </span>{" "}
              </div>
              <div>
                <h3
                  className="offcanvas-title fw-bold text-white mb-0"
                  id="addMemberLabel"
                >
                  {selectedMemberId
                    ? t("Edit Staff Member")
                    : t("Add Staff Member")}
                </h3>
                <p className="text-white fs-sm mb-0">
                  {selectedMemberId
                    ? t("Manage existing staff member details")
                    : t("Define a new staff member for your clinic")}
                </p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={resetHandler}
            ></button>
          </div>
          <div className="modal-body p-4">
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
              <form onSubmit={(e) => e.preventDefault()}>
                {/* ----- user select section start ----- */}
                <div className="form-group mb-4">
                  <label
                    htmlFor="memberName"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    {t("Invite User (search by name or email)")} *
                  </label>

                  <CreatableSelect
                    isClearable
                    styles={userSelectCustomStyles}
                    className="w-100"
                    placeholder={t("Search by name or email to invite")}
                    options={optionsToShow}
                    value={userValue}
                    onChange={userSelectionHandler}
                    onInputChange={userInputHandler}
                  />
                  {errors.user && (
                    <div className="invalid-feedback d-block">
                      {errors.user}
                    </div>
                  )}
                  {errors.userEmailIsNotValid && (
                    <div className="invalid-feedback d-block">
                      {errors.userEmailIsNotValid}
                    </div>
                  )}
                  {errors.userEmailExists && (
                    <div className="invalid-feedback d-block">
                      {errors.userEmailExists}
                    </div>
                  )}
                </div>
                {/* ----- user select section end ----- */}

                {/* ----- role select section start ----- */}
                <div className="form-group mb-4">
                  <label
                    htmlFor="role"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    {t("Role")} *
                  </label>

                  <Select
                    styles={roleSelectCustomStyles}
                    className="w-100"
                    placeholder={t("Assign a role to the staff member")}
                    options={rolesList}
                    value={roleValue}
                    onChange={roleSelectionHandler}
                  />
                  {errors.role && (
                    <div className="invalid-feedback d-block">
                      {errors.role}
                    </div>
                  )}
                </div>
                {/* ----- role select section end ----- */}

                {/* ----- status select section start ----- */}
                {/* <div className="form-group mb-4">
                <label
                  htmlFor="role"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Membership Status")}
                </label>

                <Select
                  className="w-100"
                  styles={reactSelectStyle("3px", "6px", true, false)}
                  placeholder={t("Select the member's status")}
                  options={ModeratorStatusOptions}
                  value={memberShipStatusValue}
                  onChange={memberShipStatusSelectionHandler}
                />
              </div> */}
                {/* ----- status select section end ----- */}

                {/* ----- button section start ----- */}
                <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
                  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center gap-2"
                    onClick={saveMemberHandler}
                    disabled={isAdding}
                    style={{
                      cursor: isAdding ? "not-allowed" : "pointer",
                    }}
                  >
                    {isAdding ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        {t("Saving...")}
                      </>
                    ) : (
                      <>
                        <span className="material-symbols-outlined me-1">
                          save
                        </span>{" "}
                        {t("Save Staff Member")}
                      </>
                    )}
                  </button>
                </div>
                {/* ----- button section end ----- */}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberDetailsModal;
